module.exports = __webpack_public_path__ + "static/media/video.ca82d538.svg";